
<template>
  <div class="serviceSubcontract">
    <div class="w">
      <topFilterBox @change="chooseCity">
        <div class="filter_box" slot="first">
          <div class="filter_title">
            班组类型:
          </div>
          <div class="filter_content">
            <div :class="['filter_c_item',cur_father.name == pItem.name ? 'filter_active_item' : '']"
              v-for="(pItem,pIndex) in $store.state.categoryConfig.team_type" :key="pIndex" @click="choosefather(pIndex,'team_type')">
              <el-popover placement="bottom" width="400" trigger="click" @show="showChildren" @hide="hideChildren">
                <div class="filter_children_box">
                  <div :class="['children_item', team_type.cur_sons_name.indexOf(son.name) != -1 ? 'active_children_item' : '']"
                    v-for="(son, index) in cur_father.child" :key="index" @click.stop="chooseJob(son,'team_type')">
                    {{ son.name }}
                  </div>
                </div>
                <button class="filter_c_item_name" slot="reference">
                  {{ pItem.name }}
                  <div class="choose_num" v-if="curChooseNum(pItem,'team_type')">{{ curChooseNum(pItem,'team_type') }}</div>
                </button>
              </el-popover>
            </div>
          </div>
        </div>
        <div class="filter_box" slot="three">
          <div class="filter_title">
            施工队类型:
          </div>
          <div class="filter_content">
            <div :class="['filter_c_item',cur_father.name == pItem.name ? 'filter_active_item' : '']"
              v-for="(pItem,pIndex) in $store.state.categoryConfig.build_type" :key="pIndex" @click="choosefather(pIndex,'build_type')">
              <el-popover placement="bottom" width="400" trigger="click" @show="showChildren" @hide="hideChildren">
                <div class="filter_children_box">
                  <div :class="['children_item', build_type.cur_sons_name.indexOf(son.name) != -1 ? 'active_children_item' : '']"
                    v-for="(son, index) in cur_father.child" :key="index" @click.stop="chooseJob(son,'build_type')">
                    {{ son.name }}
                  </div>
                </div>
                <button class="filter_c_item_name" slot="reference">
                  {{ pItem.name }}
                  <div class="choose_num" v-if="curChooseNum(pItem,'build_type')">{{ curChooseNum(pItem,'build_type') }}</div>
                </button>
              </el-popover>
            </div>
          </div>
        </div>

      </topFilterBox>
      <div class="list_box">
        <div class="lists_total_num_box">
          共找到<span>{{ list_data.total }}</span>条信息
        </div>
        <SubcontractList itemType="list" :lists="list_data.lists" :numberRow="2" v-if="list_data.lists.length"></SubcontractList>
        <el-empty :image-size="200" v-else></el-empty>
      </div>
      <Pager @changePage="changePage" @getList="getData" :page_size="page.page_size" :total="list_data.total"></Pager>
    </div>
  </div>
</template>

<script>
import topFilterBox from '../../components/topFilterBox.vue';
import SubcontractList from '../../components/subcontract/SubcontractList.vue';
import Tabs from '../../components/Tabs.vue'
import Pager from '../../components/pager/Pager.vue'
import mixin from '../../mixin/index'
import { mapState } from 'vuex';
export default {
  mixins: [mixin],
  components: {
    SubcontractList,
    topFilterBox,
    Pager,
    Tabs
  },
  data () {
    return {
      cur_father: {},//记录当前选择的省份
      cur_fatherIndex: -1,//记录当前选择的省份下标
      build_type: {
        cur_sons: [],//当前选择的城市
        cur_fathers_name: [],//当前选择的省份 用于显示激活css
        cur_sons_name: [],//当前选择的城市 用于显示激活css
      },
      team_type: {
        cur_sons: [],//当前选择的城市
        cur_fathers_name: [],//当前选择的省份 用于显示激活css
        cur_sons_name: [],//当前选择的城市 用于显示激活css
      },
      curChildType: '',
      filter: {
        keyword: '',
        city_codes: [],
        category_ids: [],
        job_tag_id: '',
        type: ''
      },
      type_list: [
        {
          name: '优质个人',
          id: 1
        },
        {
          name: '优质班组',
          id: 2
        },
        {
          name: '优质施工队',
          id: 3
        }
      ],
    }
  },
  created () {
    this.getData();
  },
  computed: {
    ...mapState({
      keyword: state => state.keyword,
    }),
    jobsTypeList () {
      let arr = [];
      this.$store.state.categoryConfig.job.forEach(item => {
        if (item.child) {
          item.child.forEach(elem => {
            arr.push({
              name: `${item.name}/${elem.name}`,
              id: elem.id
            })
          })
        }
      })
      return arr;
    }
  },
  methods: {
    chooseCity (val) {
      this.filter.city_codes = val;
      this.getData();
    },
    choosefather (index, type) {
      this.cur_fatherIndex = index;
      this.curChildType = type;
    },
    showChildren () {
      setTimeout(() => {
        this.cur_father = this.$store.state.categoryConfig[this.curChildType][this.cur_fatherIndex];
        console.log(this.cur_father, 'gagag')
      }, 10)
    },
    hideChildren () {
      this.cur_father = {};
    },
    curChooseNum (father, type) {
      let findfather = this[type].cur_sons.find(item => item.father_name === father.name);
      if (findfather) {
        let num = 0;
        this[type].cur_sons.forEach(item => {
          if (item.father_name == father.name) {
            num++;
          }
        });
        return num;
      } else {
        return 0;
      }
    },
    chooseJob (son, type) {
      if (this[type].cur_sons_name.indexOf(son.name) == -1) {
        if (this[type].cur_sons_name.length >= 3) {
          this.$message.error('最多只能选择三个类型');
          return;
        }
        this[type].cur_sons_name.push(son.name);
        this[type].cur_sons.push({
          ...son,
          father_name: this.cur_father.name,
          father_code: this.cur_father.code
        });
      } else {
        this[type].cur_sons_name = this[type].cur_sons_name.filter(item => item != son.name);
        this[type].cur_sons = this[type].cur_sons.filter(item => item.name != son.name);
      }
      let sonCode = this[type].cur_sons.map(item => {
        return item.id;
      })
      console.log(sonCode, 'gggggggg')
      if (type == 'team_type') {
        this.filter.category_ids = sonCode;
      } else {
        this.filter.build_type_ids = sonCode;
      }

      this.getData();
    },
    getData () {
      let params = {
        ...this.filter
      }
      params.city_codes += '';
      params.category_ids += '';
      if (this.keyword.length) {
        params.keyword = this.keyword;
      }
      for (let key in params) {
        if (!params[key] && params[key] !== 0) {
          delete params[key];
        }
      }
      this.getList('getPackageList', this.page, params);
    }
  },
  watch: {
    keyword (val) {
      this.filter.keyword = val;
      this.getData();
    }
  }


}
</script>

<style lang="scss">
.serviceSubcontract {
  min-height: 100vh;
  padding-bottom: 92px;
  .w {
    width: 1200px;
    margin: 0 auto;
  }
  .tabs_box {
    margin-bottom: 27px;
  }
  .list_box {
    .lists_total_num_box {
      font-size: 20px;
      font-weight: 400;
      color: #666666;
      margin: 24px 0 29px;
      span {
        color: #3f63ff;
      }
    }
  }
}
</style>